<div class="session-timeout-dialog">
  <div class="dialog-header">
    <mat-icon class="warning-icon">warning</mat-icon>
    <h2 class="dialog-title">Session Expired</h2>
  </div>

  <div class="dialog-content">
    <p class="dialog-message">Your session has expired. Please log in again to continue.</p>
  </div>

  <div class="dialog-actions">
    <button mat-raised-button color="primary" class="login-btn" (click)="onLogin()">
      Login
    </button>
  </div>
</div>
